import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const addProductCartApi = createAsyncThunk(
  "addProductInCart",
  async (payload) => {
    const response = await axiosInstance.post("/addCart", payload);
    return response.data;
  }
);

const addProductCartSlice = createSlice({
  name: "addProductInCart",
  initialState: {
    data: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addProductCartApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(addProductCartApi.fulfilled, (state, action) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(addProductCartApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default addProductCartSlice.reducer;
